export type Language = "pl" | "en";

const translations: Record<Language, Record<string, string>> = {
  pl: {
    tagline: "#1 B2B LinkedIn Agency",
    badge: "Darmowa diagnoza w 2 minuty",
    ctaSubtext: "Bez podawania maila",
    feature1: "W 2 minuty",
    feature2: "Indywidualne zalecenia",
    feature3: "Natychmiastowy wynik",
    feature4: "Bez podawania emaila",
    secondaryCta1: "Chcesz działać na LinkedIn natychmiast?",
    secondaryCta2: "Zostaw dane kontaktowe.",
    secondaryCtaDesc: "Nasz specjalista od LinkedIn Social Sellingu B2B skontaktuje się z Państwem i pokaże realne wyniki, jakie możemy zapewnić w prospectingu, generowaniu leadów oraz budowaniu autorytetu osobistego i firmowego w branży.",
    dialogTitle: "Zostaw dane kontaktowe",
    toastSuccess: "Dziękujemy! Nasz specjalista skontaktuje się wkrótce.",
    toastError: "Wystąpił błąd. Spróbuj ponownie.",
    
    // Testimonials
    testimonial1Name: "Anna Jacoszek",
    testimonial1Position: 'HR Manager, Kancelaria "Jasionek i Partnerzy"',
    testimonial1Quote: "Nie wiedzieliśmy jak zabrać się za LinkedIn. Próbowaliśmy bezskutecznie i bez rezultatów. Zapał szybko się kończył. Dzięki testowi wiemy, że LinkedIn ma sens, tylko nie wiedzieliśmy co i jak.",
    testimonial2Name: "Piotr Wiśniewski",
    testimonial2Position: "Właściciel, KonsGroup",
    testimonial2Quote: "Quiz pokazał nam, gdzie jesteśmy i co możemy osiągnąć.",
    testimonial3Name: "Tomasz Zieliński",
    testimonial3Position: "Dyrektor Sprzedaży, MaxOffice",
    testimonial3Quote: "Po kliku wdrożonych zaleceniach już wiemy, że LinkedIn działa. Kwestia know how;)",
    testimonial4Name: "Katarzyna Lewandowska",
    testimonial4Position: "Marketing Manager, Code4Buzz",
    testimonial4Quote: 'Dostałam wyniki quiz od szefa jako "zalecenia" ;). Byłam mega sceptyczna. Niepotrzebnie, już współpracujemy z LiFactor.',
  },
  en: {
    tagline: "#1 B2B LinkedIn Agency",
    badge: "Free diagnosis in 2 minutes",
    ctaSubtext: "No email required",
    feature1: "2 minutes",
    feature2: "Personalized recommendations",
    feature3: "Instant results",
    feature4: "No email required",
    secondaryCta1: "Want to start on LinkedIn right away?",
    secondaryCta2: "Leave your contact details.",
    secondaryCtaDesc: "Our B2B LinkedIn Social Selling specialist will contact you and show you the real results we can deliver in prospecting, lead generation, and building personal and corporate authority in your industry.",
    dialogTitle: "Leave your contact details",
    toastSuccess: "Thank you! Our specialist will contact you soon.",
    toastError: "An error occurred. Please try again.",
    
    // Testimonials
    testimonial1Name: "Anna Jacoszek",
    testimonial1Position: 'HR Manager, "Jasionek & Partners" Law Firm',
    testimonial1Quote: "We didn't know how to approach LinkedIn. We tried unsuccessfully. Thanks to the test, we know LinkedIn makes sense - we just didn't know how.",
    testimonial2Name: "Piotr Wiśniewski",
    testimonial2Position: "Owner, KonsGroup",
    testimonial2Quote: "The quiz showed us where we are and what we can achieve.",
    testimonial3Name: "Tomasz Zieliński",
    testimonial3Position: "Sales Director, MaxOffice",
    testimonial3Quote: "After implementing a few recommendations, we already know LinkedIn works. It's all about know-how ;)",
    testimonial4Name: "Katarzyna Lewandowska",
    testimonial4Position: "Marketing Manager, Code4Buzz",
    testimonial4Quote: 'I got the quiz results from my boss as "recommendations" ;). I was very skeptical. Unnecessarily - we already work with LiFactor.',
  }
};

export function getHeroTranslation(lang: Language) {
  const dict = translations[lang] || translations.en;
  return (key: string): string => dict[key] || key;
}
